import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LibSharedCommonModule } from '@solvace/common';
import { LibSharedComponentModule } from '@solvace/component';
import { SvcUserAvatarModule } from '@solvace/component/svc-user-avatar';
import { SvcStatusBadgeModule } from '@solvace/component/svc-status-badge';
import { SvcControlsModule } from '@solvace/component/svc-controls';
import { SvcMediaCarouselModule } from '@solvace/component/svc-media-carousel';
import { SvcDialogsModule } from '@solvace/component/svc-dialogs';
import { SvcButtonEllipsisModule } from '@solvace/business-component/buttons/svc-button-ellipsis';
import { SvcHighlightGroupModule } from '@solvace/business-component/forms/svc-highlight-group';
import { SvcRegistryModalHeaderModule } from '@solvace/business-component/modals/svc-registry-modal-header';
import { SvcTotalsStatusModule } from '../../general/svc-totals-status';
import { SvcReactionModule } from '../../general/svc-reaction';
import { SvcCommentsModule } from '../../general/svc-comments';
import { SvcBookmarkButtonModule } from '../../general/svc-bookmark-button';
import { SvcAudioToTextButtonModule } from '../../general/svc-audio-to-text-button';
import { SvcActionplanModule } from '../../general/svc-actionplan/svc-actionplan.module';
import { SvcPrinterModule } from '../../general/svc-printer/svc-printer.module';
import { AlertFeedTabComponent } from './alert-feed-tab/alert-feed-tab.component';
import { SvcModalAletSkeletonComponent } from './shared/components/svc-modal-alert-skeleton/svc-modal-alert-skeleton.component';
import { SvcModalAlertComponent } from './svc-modal-alert.component';
import { SvcLocationFieldModule } from '../../general/svc-location-field';
import { SvcFilledBtnModule } from '@solvace/component/svc-btn/svc-filled-btn';
import { SvcOutlinedBtnModule } from '@solvace/component/svc-btn/svc-outlined-btn';
import { SvcFormCustomFieldModule } from '@solvace/feature/general/svc-form-custom-field';

@NgModule({
  declarations: [
    SvcModalAlertComponent,
    AlertFeedTabComponent,
    SvcModalAletSkeletonComponent,
  ],
  imports: [
    LibSharedCommonModule,
    LibSharedComponentModule,
    NgxSkeletonLoaderModule,
    SvcDialogsModule,
    TranslocoModule,
    SvcControlsModule,
    SvcUserAvatarModule,
    SvcAudioToTextButtonModule,
    SvcStatusBadgeModule,
    SvcActionplanModule,
    SvcCommentsModule,
    SvcTotalsStatusModule,
    SvcReactionModule,
    SvcPrinterModule,
    SvcBookmarkButtonModule,
    SvcLocationFieldModule,
    SvcFilledBtnModule,
    SvcOutlinedBtnModule,
    SvcMediaCarouselModule,
		SvcButtonEllipsisModule,
		SvcRegistryModalHeaderModule,
		SvcHighlightGroupModule,
    SvcFormCustomFieldModule,
  ],
  exports: [
    SvcModalAlertComponent,
    AlertFeedTabComponent,
    SvcModalAletSkeletonComponent,
  ],
})
export class SvcModalAlertModule { }
